var React = require('react');

function BulletArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.25 6.8541C1.25 5.55318 2.61905 4.70707 3.78262 5.28885L13.0744 9.93476C14.3643 10.5797 14.3643 12.4203 13.0744 13.0652L3.78262 17.7111L4.34164 18.8292L3.78262 17.7111C2.61905 18.2929 1.25 17.4468 1.25 16.1459V6.8541Z","stroke":"#4d7479","strokeWidth":"2.5","key":0}),React.createElement("path",{"opacity":"0.25","d":"M5.7002 6.8541C5.7002 4.62396 8.04713 3.17347 10.0418 4.17082L19.3336 8.81672C21.5448 9.9223 21.5448 13.0777 19.3336 14.1833L10.0418 18.8292C8.04713 19.8265 5.7002 18.376 5.7002 16.1459V6.8541Z","fill":"#4d7479","key":1})]);
}

BulletArrowInline.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = BulletArrowInline;

BulletArrowInline.default = BulletArrowInline;
